import type { Instrument } from '@nutrimatic/sdk'

import { getNativeCurrency } from '@/config/native'
import { ChainId, Currency, Token } from '@/sdk'

/** Instrumento Nutrimatic → Currency del DEX (nativo o ERC-20) para logos / routing UI. */
export function instrumentToCurrency(
  instrument: Instrument | undefined | null,
  chainId: ChainId,
): Currency | undefined {
  if (!instrument) return undefined
  if (!instrument.onChainAddress) {
    return getNativeCurrency(chainId)
  }
  return new Token(
    chainId,
    instrument.onChainAddress,
    instrument.decimals ?? 18,
    instrument.symbol,
    instrument.displayName ?? instrument.symbol,
  )
}
